import script from "./recommendedgoods.vue?vue&type=script&setup=true&lang=js"
export * from "./recommendedgoods.vue?vue&type=script&setup=true&lang=js"

import "./recommendedgoods.vue?vue&type=style&index=0&id=bbed18e0&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbed18e0"]])

export default __exports__